import { render, staticRenderFns } from "./ListCongeners.vue?vue&type=template&id=575622b6"
import script from "./ListCongeners.vue?vue&type=script&lang=js"
export * from "./ListCongeners.vue?vue&type=script&lang=js"
import style0 from "./ListCongeners.vue?vue&type=style&index=0&id=575622b6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports